// extracted by mini-css-extract-plugin
export default {"header":"TestPrepare_header__nwJBp","title":"TestPrepare_title__iS3M6","surveyInstruction":"TestPrepare_surveyInstruction__ySzjx","rowButtons":"TestPrepare_rowButtons__seIeT"};